import React, { useState, useEffect, useRef } from "react";
import ProductCard from "./ProductCard";
import { getAllProducts } from "../../apiService";
import "./ProductSection.css";

const UnauthorizedProducts = () => {
  const [products, setProducts] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const categoryScrollRef = useRef(null);

  useEffect(() => {
    getAllProducts()
      .then(setProducts)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);
  console.log("allprodcuts", products);
  const allCategories = [
    ...new Set(products.map((p) => p.category?.trim().toLowerCase())),
  ];

  const toggleCategory = (cat) =>
    setSelectedCategories((prev) =>
      prev.includes(cat) ? prev.filter((c) => c !== cat) : [...prev, cat]
    );

  const filtered =
    selectedCategories.length === 0
      ? products
      : products.filter(
          (item) =>
            item.category &&
            selectedCategories.includes(item.category.trim().toLowerCase())
        );

  // Helper: assign emoji icon per category (simple mapping)
  const categoryIcons = {
    "office & stationary": "🖊️",
    luggage: "🧳",
    "personal care": "🧴",
    "kitchen & dining": "🍽️",
    accessories: "🎒",
    stationary: "📒",
    "health & personal care": "🩺",
    dining: "🍵",
    "home décor": "🏠",
    "office use": "💼",
    "personal care/ beauty": "💄",
    "health and personal": "🩹",
  };

  if (loading) return <div>Loading all products…</div>;

  // Scroll handlers for slider buttons
  const scrollCategory = (dir) => {
    const el = categoryScrollRef.current;
    if (!el) return;
    const scrollAmount = 150;
    el.scrollBy({ left: dir === "left" ? -scrollAmount : scrollAmount, behavior: "smooth" });
  };

  return (
    <div className="product-section">
      <h2>All Products</h2>
      <div className="category-bar-container">
        <div className="category-scroll-btn-wrapper">
          <button
            className="category-scroll-btn category-scroll-btn-left"
            onClick={() => scrollCategory("left")}
            aria-label="Scroll left"
          >
            &#8592;
          </button>
          <div className="category-scroll" ref={categoryScrollRef}>
            {allCategories.map((cat) => (
              <button
                key={cat}
                className={selectedCategories.includes(cat) ? "active" : ""}
                onClick={() => toggleCategory(cat)}
              >
                <span style={{ fontSize: "1.2em", marginRight: ".3em" }}>
                  {categoryIcons[cat]}
                </span>
                {cat}
              </button>
            ))}
          </div>
          <button
            className="category-scroll-btn category-scroll-btn-right"
            onClick={() => scrollCategory("right")}
            aria-label="Scroll right"
          >
            &#8594;
          </button>
        </div>
      </div>
      <div className="all-products-grid">
        {filtered.map((item, idx) => (
          <ProductCard key={idx} product={item} />
        ))}
      </div>
    </div>
  );
};

export default UnauthorizedProducts;
